import styled from 'styled-components';
import FormItem from '@/components/ui/FormItem';

export const FormItemWrapper = styled(FormItem)`
	margin-bottom: 24px;

	.ant-select-selector {
		font-size: 16px !important;
	}
`;
